import { TransitionComponent } from "./chunk-QUQRJRHE.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Dialog/Dialog.Backdrop.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DialogBackdrop = _a => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(TransitionComponent.Child, __spreadProps(__spreadValues({
    variant: "appear"
  }, rest), {
    children: /* @__PURE__ */jsx("div", {
      className: clsx("pd:dialog__backdrop", className)
    })
  }));
};
var Dialog_Backdrop_default = DialogBackdrop;
export { Dialog_Backdrop_default };